export default __webpack_public_path__ + "static/media/nodejitsu.d4ad16b2.svg";